import React from 'react'
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
const OthDuties = () => {
    const basicDutyOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const igstEXEMPTION = [{ value: 'GST No', label: 'GST No' },
    { value: 'Customer No', label: 'Customer No' },];
    const basicUnit = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className="card">
            <div className="card-body">

                <form>
                    <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3" >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                                Customs CVD
                                <span className='ms-2'>
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                </span>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Notn.
                                                </label>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-start align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Notn.
                                                </label>
                                                <span className='ms-2'>
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                </span>
                                            </div>


                                            <Select
                                                className='custom-selector w-100'
                                                options={basicDutyOpt}
                                            />


                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Item Serial No.
                                                </label>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Supp Sr. No.
                                                </label>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Duty
                                                </label>
                                            </div>
                                            <div className="d-flex">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm w-auto"
                                                    id="name"
                                                    name="name"
                                                />
                                                <span className='text-xs'>
                                                    %
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Calc. Method
                                                </label>
                                            </div>
                                            <Select
                                                className='custom-selector w-auto'
                                                options={basicDutyOpt}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Accordion defaultActiveKey="1" className="accordion-item rounded mb-3" >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                                Anti-Dumping
                                <span className='ms-2'>
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                </span></Accordion.Header>
                            <Accordion.Body>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Notn.
                                                </label>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-start align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Sr No.
                                                </label>
                                                {/* <span className='ms-2'>
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                </span> */}
                                            </div>


                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />

                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    CTH Serial No.
                                                </label>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Supp Sr. No.
                                                </label>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Quantity
                                                </label>
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-auto"
                                                id="name"
                                                name="name"
                                            />



                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Calc. Method
                                                </label>
                                            </div>
                                            <Select
                                                className='custom-selector w-auto'
                                                options={basicDutyOpt}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                    Duty
                                                </label>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm w-auto"
                                                    id="name"
                                                    name="name"
                                                />
                                                <span className='text-xs'>
                                                    %
                                                </span>
                                                <Select
                                                    className='custom-selector w-auto'
                                                    options={basicDutyOpt}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm w-auto"
                                                    id="name"
                                                    name="name"
                                                />
                                                /
                                                <Select
                                                    className='custom-selector w-auto'
                                                    options={basicDutyOpt}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>



                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Close
                        </button>

                    </div>
                </form>
            </div>
        </div>
    )
}

export default OthDuties